module.exports = __webpack_public_path__ + "static/media/qualitas-headset.110b8a6f.svg";